import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { AddButton } from 'components/atoms/button';
import { FilterBar } from 'components/molecules/filter-bar';
import { NewTaskModal } from 'components/molecules/new-task-modal';
import { Sticky } from 'components/molecules/sticky';
import { theme } from 'components/styles/theme';

interface BarProps {
  primary?: React.ReactNode;
}

export const Bar: FC<BarProps> = ({ primary = null }) => (
  <Sticky top={theme.header.height}>
    <FilterBar>
      <FilterBar.Primary data-preview-enable="true">
        {primary}
      </FilterBar.Primary>
      <FilterBar.Secondary>
        <NewTaskModal
          trigger={(toggleVisibility) => (
            <AddButton
              data-cy="buttons.create-task"
              size="small"
              onClick={toggleVisibility}
            >
              <FormattedMessage id="task.new" />
            </AddButton>
          )}
        />
      </FilterBar.Secondary>
    </FilterBar>
  </Sticky>
);
